import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";
import { redoDiscountSchema } from "./discount-schemas";

export const getDiscount = {
  name: "getDiscount" as const,
  input: z.object({ _id: zExt.objectId() }),
  output: redoDiscountSchema,
};
